<template>    
  <b-row>
    <b-col md="3">
      <b-form-group>
        <label>Fecha de orden</label>
        <flat-pickr
          class="form-control"
          :config="{ mode: 'range', minDate: 'today'}"
          v-model="rangeDate"
          :disabled="false"

        /> 
        <!-- 
          @input="setRangeDaysAndTotalNights"
         -->
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group>
        <label>Fecha de operación</label>
        <flat-pickr
          class="form-control"
          :config="{ mode: 'range', minDate: 'today'}"
          v-model="rangeDate"
          :disabled="false"

        />  
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group>
        <label>Fecha de cancelación</label>
        <flat-pickr
          class="form-control"
          :config="{ mode: 'range', minDate: 'today'}"
          v-model="rangeDate"
          :disabled="false"

        />  
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group>
        <label>Fecha de pago</label>
        <flat-pickr
          class="form-control"
          :config="{ mode: 'range', minDate: 'today'}"
          v-model="rangeDate"
          :disabled="false"

        />  
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group>
        <label>Por tipo (event, prod, pack)</label>
        <b-form-input type="date"></b-form-input> 
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group>
        <label>Por categorías</label>
         <v-select
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          multiple
          label="name"
          :options="categories"
        />
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group>
        <label>Por tipo de cliente</label>
        <b-form-input type="date"></b-form-input> 
      </b-form-group>
    </b-col>
  </b-row>    
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    vSelect,
		flatPickr
  },
   data() {
    return {
			rangeDate: null,
      dir: 'ltr',
      selected: [
        {
            "id": 18,
            "name": "Fotografia y Video",
            "section": "Categorías"
        },
        {
            "id": 13,
            "name": "Interval",
            "section": "Categorías"
        },
      ],
      categories: [
        {
            "id": 18,
            "name": "Fotografia y Video",
            "section": "Categorías"
        },
        {
            "id": 13,
            "name": "Interval",
            "section": "Categorías"
        },
        {
            "id": 12,
            "name": "Medical Services",
            "section": "Categorías"
        },
        {
            "id": 6,
            "name": "The Spa",
            "section": "Categorías"
        },
        {
            "id": 5,
            "name": "Dive Center",
            "section": "Categorías"
        },
        {
            "id": 4,
            "name": "Flights",
            "section": "Categorías"
        },
        {
            "id": 3,
            "name": "Transfer",
            "section": "Categorías"
        },
        {
            "id": 1,
            "name": "Tours",
            "section": "Categorías"
        },
        {
            "id": 11,
            "name": "The Fives Beach",
            "section": "Servicios Hoteleros"
        },
        {
            "id": 10,
            "name": "The Fives Oceanfront",
            "section": "Servicios Hoteleros"
        },
        {
            "id": 9,
            "name": "The Fives Downtown",
            "section": "Servicios Hoteleros"
        },
        {
            "id": 28,
            "name": "Certificados",
            "section": "Categorías"
        },
        {
            "id": 31,
            "name": "Upgrades",
            "section": "Categorías"
        },
        {
            "id": 32,
            "name": "Cobros Extraordinarios",
            "section": "Categorías"
        }
    ]
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
